module.exports = __webpack_public_path__ + "img/info-square.165163a8.svg";